var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _line, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 135,
    viewBox: "0 0 223 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 87,
    r: 6,
    fill: "url(#paint0_radial_4159_27075)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 120.5,
    r: 12.5,
    fill: "url(#paint1_radial_4159_27075)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 129.5,
    r: 5.5,
    fill: "url(#paint2_radial_4159_27075)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 100.5,
    r: 7.5,
    fill: "url(#paint3_radial_4159_27075)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 110,
    r: 9,
    fill: "url(#paint4_radial_4159_27075)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 96.5,
    r: 4.5,
    fill: "url(#paint5_radial_4159_27075)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173 0.5C186.722 0.5 199.122 4.22754 208.077 10.2275C217.036 16.2297 222.5 24.4673 222.5 33.5C222.5 42.5327 217.036 50.7703 208.077 56.7725C199.122 62.7725 186.722 66.5 173 66.5C159.278 66.5 146.878 62.7725 137.923 56.7725C128.964 50.7703 123.5 42.5327 123.5 33.5C123.5 24.4673 128.964 16.2297 137.923 10.2275C146.878 4.22754 159.278 0.5 173 0.5Z",
    fill: "white",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 143.367,
    y1: 54.3391,
    x2: 131.367,
    y2: 67.3391,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.089 25.768H171.369V40.248H170.089V25.768ZM164.073 31.288H167.721V32.392H164.073V31.288ZM167.177 26.104H168.425V39.496H167.177V26.104ZM159.625 35.656H160.553C161.3 35.656 161.961 35.6453 162.537 35.624C163.124 35.6027 163.673 35.56 164.185 35.496C164.708 35.432 165.236 35.3467 165.769 35.24L165.897 36.344C165.353 36.4613 164.815 36.552 164.281 36.616C163.748 36.6693 163.183 36.7067 162.585 36.728C161.999 36.7493 161.321 36.76 160.553 36.76H159.625V35.656ZM159.625 27.544H165.049V28.632H160.921V36.088H159.625V27.544ZM184.728 25.768H185.992V35.928H184.728V25.768ZM180.488 30.248H182.68V31.336H180.488V30.248ZM182.072 25.992H183.336V34.824H182.072V25.992ZM173.72 27.576H180.888V28.632H173.72V27.576ZM177.304 29.352C177.891 29.352 178.408 29.464 178.856 29.688C179.304 29.912 179.656 30.2213 179.912 30.616C180.168 31 180.296 31.4587 180.296 31.992C180.296 32.5147 180.168 32.9787 179.912 33.384C179.656 33.7787 179.304 34.088 178.856 34.312C178.408 34.5253 177.891 34.632 177.304 34.632C176.717 34.632 176.2 34.5253 175.752 34.312C175.304 34.088 174.952 33.7787 174.696 33.384C174.44 32.9787 174.312 32.5147 174.312 31.992C174.312 31.4587 174.44 31 174.696 30.616C174.952 30.2213 175.304 29.912 175.752 29.688C176.2 29.464 176.717 29.352 177.304 29.352ZM177.304 30.376C176.771 30.376 176.333 30.5253 175.992 30.824C175.661 31.112 175.496 31.5013 175.496 31.992C175.496 32.472 175.661 32.8613 175.992 33.16C176.333 33.448 176.771 33.592 177.304 33.592C177.848 33.592 178.285 33.448 178.616 33.16C178.947 32.8613 179.112 32.472 179.112 31.992C179.112 31.5013 178.947 31.112 178.616 30.824C178.285 30.5253 177.848 30.376 177.304 30.376ZM176.648 25.896H177.96V28.296H176.648V25.896ZM180.52 35.32H181.656V35.688C181.656 36.296 181.501 36.8507 181.192 37.352C180.893 37.8533 180.477 38.3013 179.944 38.696C179.421 39.08 178.824 39.4 178.152 39.656C177.48 39.912 176.771 40.088 176.024 40.184L175.56 39.16C176.083 39.0853 176.584 38.9787 177.064 38.84C177.555 38.6907 178.008 38.5093 178.424 38.296C178.84 38.0827 179.203 37.8427 179.512 37.576C179.832 37.2987 180.077 37.0053 180.248 36.696C180.429 36.376 180.52 36.04 180.52 35.688V35.32ZM180.712 35.32H181.848V35.688C181.848 36.04 181.933 36.376 182.104 36.696C182.285 37.0053 182.531 37.2987 182.84 37.576C183.16 37.8427 183.528 38.0827 183.944 38.296C184.36 38.5093 184.808 38.6907 185.288 38.84C185.779 38.9787 186.285 39.0853 186.808 39.16L186.328 40.184C185.741 40.0987 185.171 39.9653 184.616 39.784C184.061 39.6133 183.544 39.3947 183.064 39.128C182.595 38.8613 182.184 38.552 181.832 38.2C181.48 37.848 181.203 37.464 181 37.048C180.808 36.632 180.712 36.1787 180.712 35.688V35.32Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_27075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6601 65.6201H86.5601V71.3201H97.6601V65.6201Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.45 59.9099H97.46V76.8999H110.45V59.9099Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.38 48.8201H91.6799V54.3301H102.38V48.8201Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44 76.9099H103.2V82.5599H110.44V76.9099Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56 65.6201H108.69V111.03H114.56V65.6201Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56 110.53H103.2V116.75H114.56V110.53Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57 116.47H97.3899V122.22H114.57V116.47Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56 121.98H92.1499V127.73H114.56V121.98Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6101 48.8201H59.1001V54.3301H69.6101V48.8201Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3601 59.9099H51.0801V65.6099H64.3601V59.9099Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3501 65.6201H47.3201V76.9101H64.3501V65.6201Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9701 82.5901H47.3201V88.2401H52.9701V82.5901Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5501 76.9099H47.3201V82.5999H58.5501V76.9099Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2001 65.6201H75.3101V71.3201H81.2001V65.6201Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6601 71.3201H64.3601V76.9101H97.6601V71.3201Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2 76.9099H58.55V84.6699H103.2V76.9099Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.69 82.5901H52.9399V110.53H108.69V82.5901Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3801 88.24H47.3201V111.02H53.3801V88.24Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2 109.69H52.71V116.75H103.2V109.69Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.39 116.08H58.55V122.22H97.39V116.08Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16 121.98H64V127.73H92.16V121.98Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7101 111.02H47.3201V127.73H52.7101V111.02Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.55 116.75H52.71V127.74H58.55V116.75Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.99 122.22H58.48V127.73H63.99V122.22Z",
    fill: "#ED6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.38 43H59.1001V48.82H102.38V43Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.76 65.6201H114.56V127.74H119.76V65.6201Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.56 127.74H47.3201V133.48H114.56V127.74Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.32 65.6201H42V127.74H47.32V65.6201Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3599 59.9099H45.6599V65.6099H51.3599V59.9099Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.61 54.3201H49.47V59.9101H55.61V54.3201Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.11 48.8201H53.55V54.3301H59.11V48.8201Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89 48.8201H102.38V54.3301H107.89V48.8201Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.99 54.3201H106.4V59.9101H111.99V54.3201Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.15 59.9099H110.45V65.6099H116.15V59.9099Z",
    fill: "#C3313B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8499 65.6201H81.2V71.2701H86.8499V65.6201Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3101 65.6201H64.3601V71.3201H75.3101V65.6201Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6801 48.8201H69.6101V54.3301H91.6801V48.8201Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 54.3201H55.6101V59.9101H106.4V54.3201Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6601 59.9099H64.3601V65.6099H97.6601V59.9099Z",
    fill: "#FFFDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.93 92.51H59.72V95.37H73.93V92.51Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.45 92.51H82.5V95.37H96.45V92.51Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2401 100.03H71.3V103.17H85.2401V100.03Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.44 98.49H59.72V101.6H68.44V98.49Z",
    fill: "#F6AB86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7901 98.49H88.0701V101.6H96.7901V98.49Z",
    fill: "#F6AB86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4159_27075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.24 87.24) rotate(92.3859) scale(5.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4159_27075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 121) rotate(92.3859) scale(12.0104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4159_27075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.72 129.72) rotate(92.3859) scale(5.28458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4159_27075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8 100.8) rotate(92.3859) scale(7.20625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4159_27075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.36 110.36) rotate(92.3859) scale(8.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4159_27075",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.68 96.68) rotate(92.3859) scale(4.32375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#F9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBDADA",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_27075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.76,
    height: 90.48,
    fill: "white",
    transform: "translate(42 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteRed);
export default __webpack_public_path__ + "static/media/Taste_Red.7f36f7d3bb8112eb56559a2fbcd90ad5.svg";
export { ForwardRef as ReactComponent };